/**
 * Chuỗi của nhóm màn `bot` thuộc module `tro-ly-ai` (Cấu hình chatbot, Phân quyền dữ liệu) — tạm tách tệp khi dựng song
 * song, sẽ gộp vào `vi.ts`. Khoá cấp một mang tiền tố `troLyAiBot`; sâu tối đa hai cấp dưới nó (kiểu `BanDich` chỉ đỡ ba
 * cấp).
 */
export const viBot = {
  troLyAiBot: {
    tieuDe: 'Cấu hình chatbot AI',
    phuDe: 'Bot đang bật và trả lời được sẽ hiện ở màn “Trò chuyện với bot”.',
    themChatbot: 'Thêm chatbot',
    chuaCoBot: 'Chưa có chatbot nào.',
    themBotDauTien: 'Thêm bot đầu tiên.',
    quanTriTao: 'Quản trị viên tạo bot.',
    chonBot: 'Chọn một chatbot bên trái để xem cấu hình.',
    danhSachBot: 'Danh sách chatbot',
    timBot: 'Tìm chatbot',
    khongTimThayBot: 'Không có chatbot nào khớp từ khoá.',
    tat: 'tắt',
    dangChay: 'Đang chạy',
    dangBat: 'Đang bật',
    dangTat: 'Đang tắt',
    tatTuDong: 'Đang tắt vì không còn nguồn nào để tra.',
    nguonDangTat: '{{n}} nguồn · đang tắt',
    moBot: 'Mở cuộc trò chuyện với {{ten}}',
    xacNhanXoa: 'Xoá chatbot “{{ten}}”?',
    xacNhanXoaGhi: 'Cấu hình chatbot sẽ bị xoá và không khôi phục được. Tài liệu và dữ liệu của chatbot không bị ảnh hưởng.',
    xoaChatbot: 'Xoá chatbot',
    daXoa: 'Đã xoá chatbot.',
    daLuuCauHinh: 'Đã lưu cấu hình.',
    daTaoChatbot: 'Đã tạo chatbot.',
    taoChatbot: 'Tạo chatbot',
    thuTroChuyen: 'Thử trò chuyện',
    botTuTatDam: 'Bot này đã bị tắt tự động',
    botTuTatSau: 'vì nguồn cuối cùng của nó bị xoá. Gắn một bộ tri thức hoặc một nguồn dữ liệu ở tab Tri thức rồi bật lại.',
    conViec: 'Còn {{n}} việc trước khi bật được bot',
    viecDatTen: 'Đặt tên bot',
    viecGanNguon: 'Gắn ít nhất một bộ tri thức hoặc nguồn dữ liệu',
    chatbotMoi: 'Chatbot mới',
    chuaTao: 'Chưa tạo',
    botChuaTao: 'Bot chưa được tạo — điền tên rồi bấm Tạo chatbot.',
    coThayDoi: 'Có thay đổi chưa lưu ở {{n}} tab',
    daLuuHet: 'Mọi thay đổi đã được lưu',
    hoanTac: 'Hoàn tác',
    tabCanSua: 'cần sửa',
    tabChuaLuu: 'có thay đổi chưa lưu',
    boThayDoiHoi: 'Bỏ các thay đổi chưa lưu?',
    boThayDoiGhi: 'Bạn đang sửa dở cấu hình bot này. Chuyển đi bây giờ thì các thay đổi chưa lưu sẽ mất.',
    boThayDoi: 'Bỏ thay đổi',
    mucCoBan: 'Thông tin cơ bản',
    tenChatbot: 'Tên chatbot',
    moTaNgan: 'Mô tả ngắn',
    mucDich: 'Mục đích sử dụng',
    loiChao: 'Lời chào',
    mucNguon: 'Nguồn tri thức đầu vào',
    mucNguonMo: 'Bỏ trống cả hai nghĩa là bot không tra cứu được gì — không phải tra cứu tất cả.',
    khongNguonKO: 'Chưa chọn nguồn nào. Bot ở chế độ “trong phạm vi” sẽ trả lời “không tìm thấy” cho mọi câu, nên không bật được.',
    khongNguonMo: 'Chưa chọn nguồn nào. Bot vẫn trả lời bằng kiến thức chung của mô hình, nhưng câu trả lời không dựa trên tài liệu hay số liệu của tổ chức.',
    boTriThuc: 'Bộ tri thức (tài liệu)',
    chuaCoBo: 'Chưa có bộ nào.',
    nguonSoLieu: 'Nguồn dữ liệu (số liệu)',
    chonNhieu: 'chọn một hoặc nhiều',
    chuaCoNguon: 'Chưa có nguồn nào.',
    tranNguon: 'Tối đa {{n}} nguồn — mỗi nguồn là một lượt tra riêng cho mỗi câu hỏi.',
    traWeb: 'Trang web của tổ chức',
    traWebMo: 'Dùng khi số liệu và tài liệu không trả lời được — ví dụ “bên bạn có giao hàng tỉnh không”.',
    traWebGhi: 'Mỗi dòng một tên miền, không kèm https:// và đường dẫn. Tên miền gốc gồm cả tên miền con. Tối đa 20.',
    traWebRong: 'chưa khai báo — bot không tra web',
    traWebKhacGoc: 'Khác với “Tên miền được phép nhúng”: ô kia quy định trang nào được nhúng khung chat, ô này quy định bot được đọc trang nào.',
    traWebViDu: 'congty.com\ntin.congty.com',
    mucCachTraLoi: 'Cách trả lời',
    phamViTraLoi: 'Phạm vi trả lời',
    modeKnowledgeOnly: 'Chỉ trả lời trong phạm vi tài liệu',
    modeKnowledgeOnlyMo: 'Không tìm thấy trong tài liệu hay số liệu thì bot nói không biết, không đoán.',
    modeOpen: 'Được trả lời ngoài phạm vi',
    modeOpenMo: 'Bot được trả lời bằng kiến thức chung của mô hình. Khi đó câu trả lời không có nguồn trích dẫn.',
    trichNguon: 'Trích nguồn trong câu trả lời',
    trichNguonMo: 'Bật thì câu trả lời nêu tên tài liệu đã dẫn (ví dụ “Theo tài liệu quy_dinh.pdf, …”). Tắt thì trả lời thẳng vào nội dung, không nêu tên tệp.',
    mucHuongDan: 'Hướng dẫn hệ thống',
    mucHuongDanMo: 'Giọng điệu và phạm vi trả lời. Không nhập số liệu vào đây — số liệu được lấy từ nguồn dữ liệu, còn con số viết ở đây sẽ lỗi thời mà không ai phát hiện.',
    mucFaq: 'Câu hỏi thường gặp',
    mucFaqMo: 'Câu hỏi đã có sẵn câu trả lời, không cần tra cứu. Dùng cho những câu mà câu trả lời soạn sẵn tốt hơn kết quả tra cứu.',
    cauHoi: 'Câu hỏi',
    cauTraLoi: 'Câu trả lời',
    themCauHoi: 'Thêm câu hỏi',
    xoaCauHoi: 'Xoá câu hỏi {{i}}',
    cauHoiSo: 'Câu hỏi {{i}}',
    cauTraLoiSo: 'Câu trả lời {{i}}',
    mucKichBan: 'Kịch bản',
    mucKichBanMo: 'Câu hỏi khớp tình huống thì bot đi theo một quy trình nhiều bước. Khác câu hỏi thường gặp ở chỗ kịch bản khớp theo tình huống, không theo một câu cụ thể.',
    batKichBan: 'Bật kịch bản cho bot này',
    themKichBan: 'Thêm kịch bản',
    chuaDatTen: '(chưa đặt tên)',
    xoaKichBan: 'Xoá kịch bản {{ten}}',
    suaKichBan: 'Sửa kịch bản {{ten}}',
    kbThongTin: '{{n}} thông tin bắt buộc',
    kbBuoc: '{{n}} bước',
    kbQuyTac: '{{n}} quy tắc',
    kbChuaCoBuoc: 'chưa có bước nào',
    kenhGiaoTiep: 'Kênh giao tiếp',
    kenhGhi: 'Áp dụng cho cả khung chat nhúng lẫn màn Trò chuyện với bot. Chữ luôn hiển thị ở cả ba lựa chọn.',
    giongDoc: 'Giọng đọc',
    giongGhi: 'Người xem khung nhúng không chọn được giọng, nên chọn ở đây.',
    giongChuaCo: 'Máy chủ chưa có giọng đọc nào — cần cấu hình khoá Gemini.',
    mucKhac: 'Khác',
    luuLichSu: 'Lưu lịch sử hội thoại',
    vungNguyHiem: 'Xoá chatbot này',
    tab: {
      tongQuan: 'Tổng quan',
      triThuc: 'Tri thức',
      hanhVi: 'Hành vi',
      giaoTiep: 'Giao tiếp',
      quyen: 'Quyền truy cập',
      nhung: 'Nhúng',
      nangCao: 'Nâng cao',
    },
    chonNguon: {
      dem: '{{n}} đã chọn',
      demTran: '{{n}}/{{tong}} đã chọn',
      chuaChon: 'Chưa chọn mục nào.',
      tim: 'Tìm trong {{nhan}}',
      khongKhop: 'Không mục nào khớp từ khoá.',
      chuaSanSang: 'Chưa sẵn sàng ({{n}})',
    },
    kenh: {
      van_ban: 'Chỉ văn bản',
      van_banMo: 'Gõ và đọc. Không mic, không phát tiếng.',
      giong_noi: 'Giọng nói',
      giong_noiMo: 'Có mic, và tự đọc câu trả lời thành tiếng.',
      ca_hai: 'Giọng nói + văn bản',
      ca_haiMo: 'Có mic, có nút loa — bấm mới đọc.',
    },
  },

  troLyAiBotNhung: {
    nhungChuaChay: 'Chưa hoạt động',
    nhungChuaChayGhi: 'Bong bóng chat chỉ hiện khi đủ ba điều kiện: khung nhúng đang mở, tên miền của trang có trong danh sách dưới đây, và đoạn mã được dán đúng nguyên văn.',
    moKhungRaNgoai: 'Cho phép nhúng khung chat ra bên ngoài',
    moKhungGhi: 'Bot đang chạy trong hệ thống vẫn có thể chưa mở ra internet.',
    dangMo: 'Đang mở',
    dangDong: 'Đang đóng',
    khoaKhongPhaiMatKhau: 'Khoá nhúng không phải mật khẩu',
    khoaGhi: 'Khoá nằm trong mã nguồn trang nên ai xem mã nguồn cũng đọc được.',
    khoaDsGocDam: 'Danh sách tên miền',
    khoaDsGocSau: 'chặn trang khác nhúng bot, nhưng không ngăn được người gọi bằng công cụ dòng lệnh.',
    khoaTranDam: 'Giới hạn mỗi phút',
    khoaTranSau: 'là lớp bảo vệ duy nhất còn tác dụng với những người ấy.',
    khoaNhung: 'Khoá nhúng',
    anKhoa: 'Ẩn khoá',
    hienKhoa: 'Hiện khoá',
    saoChep: 'Sao chép',
    daSaoChep: 'Đã sao chép {{ten}}.',
    khongSaoChepDuoc: 'Trình duyệt không cho phép sao chép ở đây — hãy bôi đen rồi sao chép thủ công.',
    khoa: 'khoá',
    doanMa: 'đoạn mã',
    khoaGhiChu: 'Do nền tảng tạo, không sửa được. Việc che ở đây chỉ để tránh lộ khi trình chiếu — khoá vẫn nằm trong mã nguồn trang của bạn.',
    doanMaDan: 'Đoạn mã dán vào trang',
    khoaApiHuongDan: 'Thay <TENANT_API_KEY> bằng một khoá API của tenant: tạo ở màn Khoá API, chỉ cấp quyền tro-ly-ai:nhung:hoi. Khoá này nằm trong mã trang công khai như khoá nhúng — giới hạn nguồn gốc và trần tần suất mới là hàng rào.',
    saoChepDoanMa: 'Sao chép đoạn mã',
    khoaSinhKhiLuu: 'Khoá nhúng được tạo khi lưu lần đầu với khung nhúng đang mở.',
    xoayKhoa: 'Cấp lại khoá',
    xoayKhoaHoi: 'Cấp khoá nhúng mới?',
    xoayKhoaCanhBao: 'Khoá cũ hết hiệu lực ngay, và mọi trang đang nhúng bot sẽ không hiện bong bóng chat cho tới khi được cập nhật đoạn mã mới. Không thể hoàn tác.',
    xoayKhoaLam: 'Cấp khoá mới',
    xoayKhoaXong: 'Đã cấp khoá mới. Hãy gửi lại đoạn mã cho những trang bạn muốn tiếp tục nhúng.',
    gocDuocPhep: 'Tên miền được phép nhúng',
    gocLaSao: 'đang là * — mọi trang trên internet đều nhúng được',
    gocRong: 'đang trống — nghĩa là không tên miền nào nhúng được',
    gocGhiChu: 'Mỗi dòng một địa chỉ đầy đủ, gồm cả https:// và không kèm đường dẫn, ví dụ https://tenmien.com. Một dòng * là cho phép mọi tên miền.',
    gocViDu: 'https://congty.com\nhttps://tra-cuu.congty.com\n\nhoặc một dòng *  để mở cho mọi gốc',
    gocCanhBaoDam: 'Đang cho phép mọi tên miền.',
    gocCanhBaoSau: 'Bất kỳ trang nào trên internet cũng nhúng được bot này. Lớp bảo vệ còn lại chỉ là giới hạn mỗi phút bên dưới.',
    tranChung: 'Số câu hỏi mỗi phút — tất cả khách',
    tranMotNguoi: 'Số câu hỏi mỗi phút — mỗi khách',
    tranMotNguoiGhi: 'Cần cả hai: thiếu giới hạn cho mỗi khách thì một người dùng hết phần chung.',
    vaiNhung: 'Vai trò của bot nhúng',
    vaiNhungRong: 'Không đọc số liệu (khuyến nghị)',
    vaiNhungGhi: 'Để trống: bot chỉ trả lời từ bộ tri thức, câu hỏi thường gặp và kịch bản — không truy cập số liệu.',
    vaiNhungCanhBao: 'Vai trò “{{vai}}” đọc được {{n}} bảng trên nguồn “{{nguon}}”. Khách trên trang công khai sẽ đọc được đúng những bảng đó.',
    vaiNhungChuaCoNguon: 'Bot này chưa gắn nguồn dữ liệu, nên chọn vai trò chưa có tác dụng gì. Gắn nguồn ở tab Tri thức.',
    vaiNhungTomTat: 'Vai trò “{{vai}}” đọc được số liệu ở {{ok}}/{{tong}} nguồn của bot.',
    vaiNhungDongChuaTick: '“{{nguon}}”: chưa cấp bảng nào — bot nhúng sẽ không đọc được nguồn này.',
    vaiNhungDongToanBo: '“{{nguon}}”: mức toàn bộ nguồn — khách vãng lai đọc được mọi bảng, kể cả bảng đồng bộ về sau.',
    vaiNhungDongChuaCapKhuon: '“{{nguon}}”: vai trò chưa được cấp truy vấn mẫu nào — bot nhúng sẽ không gọi được nghiệp vụ trên nguồn này.',
    vaiNhungConLai: '…và {{n}} nguồn nữa.',
    vaiNhungChuaCapKhuon: 'Vai trò “{{vai}}” chưa được cấp truy vấn mẫu nào trên nguồn “{{nguon}}” — bot nhúng sẽ không gọi được nghiệp vụ nào. Mở Phân quyền dữ liệu → Theo truy vấn mẫu để cấp.',
    vaiNhungKhuon: 'Vai trò “{{vai}}” gọi được truy vấn mẫu trên nguồn “{{nguon}}”. Khách trên trang công khai hỏi được đúng những nghiệp vụ đã cấp cho vai trò này.',
    vaiNhungChuaTick: 'Vai trò “{{vai}}” chưa được cấp bảng nào trên nguồn “{{nguon}}” — bot nhúng sẽ không đọc được số liệu. Mở màn Phân quyền dữ liệu, chọn đúng nguồn này rồi cấp quyền.',
    vaiNhungToanBoNguon: 'Vai trò “{{vai}}” đang mở toàn bộ nguồn “{{nguon}}” — khách trên trang công khai đọc được mọi bảng, kể cả bảng thêm về sau. Cân nhắc chuyển sang mức “Theo bảng”.',
    vaiNhungDangDo: 'Đang kiểm tra quyền của vai trò này trên nguồn của bot...',
    vaiNhungKhongDoDuoc: 'Chưa kiểm tra được quyền của vai trò này. Xem lại ở màn Phân quyền dữ liệu.',
    moHinhNhung: 'Mô hình trả lời cho bot nhúng',
    moHinhNhungMacDinh: 'Mặc định của máy chủ',
    moHinhNhungGhi: 'Để trống: bot nhúng dùng mô hình mặc định của máy chủ.',
    moHinhNhungDangDung: 'Đang dùng {{ma}}.',
    moHinhNhungThieuKhoa: '“{{ten}}” chưa có khoá API trên máy chủ — chọn nó thì bot nhúng không trả lời được. Chọn mô hình khác, hoặc để trống để dùng mặc định.',
    moHinhNhungLa: 'Máy chủ không còn cung cấp “{{ten}}”. Bot nhúng vẫn trả lời, nhưng bằng mô hình mặc định chứ không phải mô hình ghi ở đây. Hãy chọn lại một mô hình trong danh sách.',
    moHinhNhungKhongDoDuoc: 'Chưa tải được danh mục mô hình. Bot nhúng vẫn chạy — chưa xác định được mô hình này còn dùng được hay không.',
    moHinhChuaCauHinh: 'chưa cấu hình',
    tieuDeKhung: 'Tiêu đề khung',
    mauChuDao: 'Màu chủ đạo',
    chonMau: 'Chọn màu chủ đạo',
    mauSaiDang: 'Mã màu phải có dạng # kèm 3 hoặc 6 chữ số hệ 16. Máy chủ từ chối dạng khác.',
    viTri: 'Vị trí bong bóng chat',
    gocDuoiPhai: 'Góc dưới phải',
    gocDuoiTrai: 'Góc dưới trái',
  },

  troLyAiBotQuyenTruyCap: {
    tieuDe: 'Ai được dùng bot này',
    dem: '{{n}}/{{tong}} vai trò thấy bot này',
    giaiThich: 'Vai trò được chọn sẽ thấy bot ở màn “Trò chuyện với bot” và trò chuyện được với bot. Người có nhiều vai trò được cộng quyền. Dữ liệu bot đọc được vẫn theo vai trò của người hỏi — thiết lập ở màn Phân quyền dữ liệu.',
    luuRieng: 'Quyền truy cập được lưu riêng bằng nút bên dưới, không qua nút Lưu cấu hình, và có hiệu lực cả khi bot chưa bật.',
    luu: 'Lưu quyền truy cập',
    hoanTac: 'Hoàn tác',
    daLuu: 'Đã lưu quyền truy cập bot.',
    chuaTao: 'Bot chưa được tạo',
    chuaTaoMoTa: 'Tạo bot trước, rồi quay lại tab này để chọn vai trò được dùng nó.',
    khongCoVai: 'Tổ chức chưa có vai trò nào để cấp.',
  },

  troLyAiBotKichBan: {
    them: 'Thêm kịch bản mới',
    sua: 'Sửa kịch bản',
    luu: 'Lưu kịch bản',
    ten: 'Tên kịch bản',
    moTaNgan: 'Mô tả ngắn',
    moTaNganGhi: 'Khi nào kịch bản này được dùng — mô tả bằng lời, không phải biểu thức.',
    cacBuoc: 'Các bước hội thoại',
    cacBuocGhi: 'Theo thứ tự — “hỏi thu nhập” trước “đề xuất hạn mức” là một quy trình khác hẳn chiều ngược lại. Bước nào cần lấy thông tin của khách thì chọn “Thu thập”: bot sẽ hỏi đúng thứ tự này và không kết thúc khi còn thiếu.',
    buocSo: 'Bước {{i}}',
    quyTac: 'Quy tắc cần lưu ý',
    quyTacGhi: 'Điều cấm và ràng buộc — đúng ở mọi bước, nên không đánh số.',
    quyTacSo: 'Quy tắc {{i}}',
    quyTacViDu: 'VD: Không được bỏ qua bước',
    duaLen: 'Đưa bước {{i}} lên',
    duaXuong: 'Đưa bước {{i}} xuống',
    xoaBuoc: 'Xoá bước {{i}}',
    xoaQuyTac: 'Xoá quy tắc {{i}}',
    themBuoc: 'Thêm bước',
    themQuyTac: 'Thêm quy tắc',
    kieuCua: 'Kiểu của {{ten}}',
    kieuVanBan: 'Văn bản',
    kieuSo: 'Số',
    kieuDienThoai: 'Số điện thoại',
    kieuEmail: 'Email',
    kieuNgay: 'Ngày',
    thuThap: 'Thu thập',
    thuThapGhi: 'Bước này phải lấy được giá trị từ khách',
    thuThapCua: 'Thu thập ở bước {{i}}',
    viDuBuoc: 'VD: Hỏi số điện thoại',
    gopTuBanKhaiCu: '{{n}} thông tin bắt buộc khai báo theo định dạng cũ đã được gộp vào danh sách bước bên dưới. Lưu lại một lần để chuyển sang định dạng mới.',
  },

  troLyAiBotGiong: {
    giongDoc: 'Giọng đọc',
    dungNgheThu: 'Dừng nghe thử',
    ngheThuHong: 'Không nghe thử được — {{loi}}',
    chuaCoGiongCauHinh: 'Máy chủ chưa cấu hình giọng đọc, nên bot sẽ không đọc thành tiếng. Cần cấu hình khoá Gemini cho dịch vụ trợ lý.',
    giongMacDinhChon: 'Mặc định — máy chủ chọn giọng đầu danh sách',
    ngheThuGiong: 'Nghe thử giọng này',
    ngheThuMacDinh: 'Chọn một giọng cụ thể rồi mới nghe thử được — “Mặc định” do máy chủ chọn khi chạy.',
  },

  troLyAiBotViDu: {
    kbTen: 'VD: Mở thẻ tín dụng',
    kbTrigger: 'VD: Khách hàng muốn mở thẻ tín dụng',
    botTen: 'Trợ lý vận hành nước sạch',
    botMoTa: 'Trả lời câu hỏi vận hành và tra quy định nội bộ.',
    botMucDich: 'Phục vụ đội vận hành: tra số liệu thất thoát theo tháng và tra quy định bảo hành thiết bị.',
    botHuongDan: 'Trả lời ngắn gọn, xưng “tôi”. Câu nào không có trong tài liệu hay số liệu thì nói thẳng là không biết.',
    khungTieuDe: 'Trợ lý vận hành',
    khungLoiChao: 'Xin chào! Tôi có thể giúp gì cho bạn?',
  },

  troLyAiBotQuyenDuLieu: {
    tieuDe: 'Phân quyền dữ liệu',
    phuDe: 'Mặc định từ chối: chưa cấp quyền thì không đọc được, kể cả với quản trị. Cột bị ẩn được chặn ở mọi vị trí trong câu truy vấn, không chỉ ở phần hiển thị — vì lọc hay sắp xếp theo cột lương cũng đủ làm lộ thông tin.',
    nguon: 'Nguồn dữ liệu',
    chiXem: 'Chỉ xem',
    luuThayDoi: 'Lưu thay đổi',
    daLuu: 'Đã lưu',
    daLuuPhanQuyen: 'Đã lưu phân quyền.',
    khongSuaDuoc: 'Vai trò của bạn không sửa được ma trận phân quyền.',
    khongSuaDuocGhi: 'Ma trận phân quyền cho biết dữ liệu nhạy cảm nằm ở đâu, nên việc xem nó cũng cần quyền riêng. Bạn vẫn xem được quyền của chính mình ở phần dưới.',
    chuaCoNguon: 'Chưa có nguồn dữ liệu nào',
    chuaCoNguonMo: 'Thêm nguồn ở Kết nối nguồn trước, rồi quay lại đây cấp quyền.',
    sangKetNoi: 'Sang Kết nối nguồn',
    vai: 'Vai trò',
    danhSachVai: 'Danh sách vai trò',
    khongCoVai: 'Tổ chức chưa có vai trò nào.',
    mucQuyen: 'Mức quyền của vai trò',
    mucNone: 'Không đọc gì',
    mucTables: 'Theo bảng',
    mucFull: 'Toàn bộ nguồn',
    canhBaoFull: 'Bảng mới đồng bộ về cũng đọc được ngay, không cần cấp quyền lại.',
    fullMoTa: 'Vai trò này đọc được mọi bảng của nguồn, không cột nào bị ẩn.',
    chuaMoBang: 'Vai trò này chưa được cấp quyền đọc bảng nào. Chọn “Theo bảng” để cấp từng bảng.',
    tomTatNone: 'Không đọc gì',
    tomTatFull: 'Toàn bộ nguồn',
    tomTatChuaMo: 'Chưa cấp bảng nào',
    tomTatBang: '{{n}} bảng',
    tomTatBangGiau: '{{n}} bảng · ẩn {{c}} cột',
    nhanDong: 'không cấp',
    nhanToanBo: 'toàn bộ',
    nhanBang: '{{n}} bảng',
    giauCot: 'ẩn {{n}} cột',
    soCot: '{{n}} cột',
    huongDanCotTruoc: 'Bấm vào một cột để',
    huongDanCotDam: 'ẩn',
    huongDanCotSau: 'cột đó. Cột đang sáng là cột đọc được — kể cả cột mới đồng bộ về sau này.',
    dangGiau: 'Đang ẩn — bấm để hiện',
    dangHien: 'Đang hiện — bấm để ẩn',
    quyenCuaToi: 'Quyền hiện tại của bạn',
    quyenCuaToiVai: 'Quyền hiện tại của bạn — {{vai}}',
    giauDs: ' (ẩn {{ds}})',
    chuaCoNguonMoChoVai: 'Chưa có nguồn nào được cấp cho vai trò này. Mặc định là từ chối khi chưa cấp quyền.',
    timBang: 'Tìm bảng theo tên...',
    demBang: 'Đã cấp {{mo}}/{{tong}} bảng · đang hiện {{hien}}',
    khongKhopBang: 'Không có bảng nào khớp bộ lọc.',
    tabTheoBang: 'Theo bảng và cột',
    tabTheoKhuon: 'Theo truy vấn mẫu',
    locBang: {
      tat_ca: 'Tất cả',
      da_mo: 'Đã cấp',
      chua_mo: 'Chưa cấp',
    },
  },

  troLyAiBotQuyenKhuon: {
    chuaCoKhuon: 'Nguồn này chưa khai báo truy vấn mẫu nào',
    chuaCoKhuonMoTa: 'Vào trang Truy vấn mẫu để khai báo truy vấn mẫu cho nguồn này trước, rồi quay lại đây cấp quyền.',
    dangNgu: 'Nguồn này đang khai báo bằng câu hỏi nên ma trận dưới đây chưa có hiệu lực. Ma trận sẽ có hiệu lực ngay khi bạn chuyển sang khai báo bằng truy vấn mẫu.',
    muc: 'Mức quyền truy vấn mẫu',
    mucNone: 'Không dùng được truy vấn mẫu nào',
    mucFull: 'Dùng được mọi truy vấn mẫu',
    mucChon: 'Chỉ nhóm và truy vấn mẫu được chọn',
    capRiengNhan: 'Cấp riêng',
    chanNhan: 'Chặn riêng',
    chanViSao: 'Chọn cả nhóm để cấp mọi truy vấn mẫu trong nhóm, hoặc “Cấp riêng” từng truy vấn mẫu. “Chặn riêng” được ưu tiên hơn cả cấp theo nhóm lẫn cấp toàn bộ.',
    chuaChayThuNhan: 'chưa chạy thử',
    chuaChayThuViSao: 'Truy vấn mẫu chưa chạy thử sẽ không được dùng dù đã cấp quyền.',
    soKhuon: '{{n}} truy vấn mẫu',
    luu: 'Lưu phân quyền truy vấn mẫu',
    daLuu: 'Đã lưu phân quyền truy vấn mẫu.',
    tomTatNone: 'Chưa cấp truy vấn mẫu nào',
    tomTatFull: 'Mọi truy vấn mẫu của nguồn',
    tomTatChon: '{{nhom}} nhóm · {{khuon}} truy vấn mẫu',
    tomTatChan: '{{n}} truy vấn mẫu bị chặn riêng',
    duocDung: 'Dùng được',
    khongDung: 'Không dùng được',
  },
} as const;
